import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

export type AppPadding = {
    top?: number;
    bottom?: number;
    bottomMenu?: number;
};

type AppState = {
    marketCode: string;
    languageCode: string;
    isInitialized: boolean;
    padding: AppPadding;
};

const getInitialState = (): AppState => {
    return {
        marketCode: '',
        languageCode: '',
        isInitialized: false,
        padding: {},
    };
};

export const slice = createSlice({
    name: 'app',
    initialState: getInitialState(),
    reducers: {
        setMarketCode: (state, action: PayloadAction<string>) => {
            return {...state, marketCode: action.payload};
        },
        setLanguageCode: (state, action: PayloadAction<string>) => {
            return {...state, languageCode: action.payload};
        },
        setInitialized: (state, action: PayloadAction<boolean>) => {
            return {...state, isInitialized: action.payload};
        },
        setPadding: (state, action: PayloadAction<AppPadding>) => {
            return {...state, padding: action.payload};
        },
    },
});

export const {setMarketCode, setLanguageCode, setInitialized, setPadding} = slice.actions;
export default slice.reducer;
